export default "__VITE_PUBLIC_ASSET__378d341e__"